import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useParams } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';

function EditarFactura() {
    const { id } = useParams();
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    // Estados del formulario
    const [fecha, setFecha] = useState('');
    const [vencimiento, setVencimiento] = useState('');
    const [profesional, setProfesional] = useState('');
    const [sede, setSede] = useState('');
    const [prefijo, setPrefijo] = useState('');
    const [numeroFactura, setNumeroFactura] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [tipoPago, setTipoPago] = useState('contado');
    
    // Estados para datos de API
    const [profesionales, setProfesionales] = useState([]);
    const [parametrosFev, setParametrosFev] = useState([]);
    
    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');
    const [codigoResponsabilidad, setCodigoResponsabilidad] = useState('No responsable');
    const [codigoRegimen, setCodigoRegimen] = useState('No responsable de IVA');
    const [codigoImpuesto, setCodigoImpuesto] = useState('No causa');
    
    // Modal verificar datos paciente
    const [showModalVerificar, setShowModalVerificar] = useState(false);
    const [datosVerificar, setDatosVerificar] = useState({});
    
    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);
    
    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);
    
    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;
    const [sedes, setSedes] = useState([]);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar datos de la factura
        axios.get('/factura/' + id + '?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    const factura = response.data;
                    setFecha(factura.fecha_emision);
                    setVencimiento(factura.fecha_vence);
                    setProfesional(factura.users_id);
                    setSede(factura.sedes_id);
                    setPrefijo(factura.parametrosfev_id);
                    setNumeroFactura(factura.numero_factura);
                    setMetodoPago(factura.forma_pago);
                    setTipoPago(factura.tipo_pago || 'contado');
                    setPacienteId(factura.paciente_id);
                    setTotalBruto(factura.valor_bruto);
                    setTotalPagar(factura.valor_total);
                    setObservaciones(factura.observaciones || '');
                    setCodigoResponsabilidad(factura.codigo_responsabilidad || 'No responsable');
                    setCodigoRegimen(factura.codigo_regimen || 'No responsable de IVA');
                    setCodigoImpuesto(factura.codigo_impuesto || 'No causa');
                    
                    // Cargar detalles con información de lista de precios
                    const productosConDetalle = factura.detalle.map(detalle => ({
                        id: detalle.id,
                        id_listadeprecios: detalle.id_listadeprecios,
                        codigo: detalle.lista_precio?.codigo || '',
                        descripcion: detalle.lista_precio?.nombre || '',
                        cantidad: detalle.cantidad,
                        precio: parseFloat(detalle.precio_unitario),
                        porcentaje: parseFloat(detalle.porcentaje),
                        impuesto: parseFloat(detalle.impuesto),
                        total: parseFloat(detalle.total)
                    }));
                    setProductos(productosConDetalle);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar parámetros FEV
        axios.get('/parametros-fev?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setParametrosFev(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos', config)
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar sedes
        axios.get('/sedes?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setSedes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, [id]);

    useEffect(() => {
        if (pacienteId && pacientes.length > 0) {
            const paciente = pacientes.find(p => p.id === pacienteId);
            if (paciente) {
                const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                setNombrePaciente(nombreCompleto);
                setTipoPaciente(paciente.tipo_documento || 'CC');
                setDocumentoPaciente(paciente.numero_documento || '');
                setCodigoResponsabilidad(paciente.codigo_responsabilidad || 'No responsable');
                setCodigoRegimen(paciente.codigo_regimen || 'No responsable de IVA');
                setCodigoImpuesto(paciente.codigo_impuesto || 'No causa');
            }
        }
    }, [pacienteId, pacientes]);

    const getPrefijosFiltrados = () => {
        return parametrosFev.filter(param => 
            param.tipo === 'Factura Electronica' && 
            param.users_id == profesional &&
            param.estado == 1
        );
    };

    const getListaPreciosFiltrada = () => {
        if (!clasificacionFiltro) {
            return listaPrecios;
        }
        
        return listaPrecios.filter(item => {
            return item.clasificacion === clasificacionFiltro;
        });
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                descripcion: servicio.nombre,
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                
                // Recalcular total del producto
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;
                
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let bruto = 0;
        let pagar = 0;

        productosArray.forEach(producto => {
            bruto += (producto.precio * producto.cantidad);
            pagar += producto.total;
        });

        setTotalBruto(bruto);
        setTotalPagar(pagar);
    };

    const getPacientesFiltrados = () => {
        if (!busquedaPaciente) return pacientes;
        
        return pacientes.filter(paciente => {
            const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim().toLowerCase();
            const documento = paciente.numero_documento || '';
            const busqueda = busquedaPaciente.toLowerCase();
            
            return nombreCompleto.includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        const inicio = (paginaActual - 1) * pacientesPorPagina;
        const fin = inicio + pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setCodigoResponsabilidad(paciente.codigo_responsabilidad || 'No responsable');
        setCodigoRegimen(paciente.codigo_regimen || 'No responsable de IVA');
        setCodigoImpuesto(paciente.codigo_impuesto || 'No causa');
        setShowModalPaciente(false);
    };

    const abrirModalVerificar = async () => {
        if (!pacienteId) {
            alert('Seleccione un paciente primero');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteId}`, config);
            setDatosVerificar(response.data[0]);
            setShowModalVerificar(true);
        } catch (error) {
            alert('Error al cargar datos del paciente');
        }
    };

    const actualizarPaciente = async () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        try {
            await axios.put('/paciente', datosVerificar, config);
            alert('Datos del paciente actualizados');
            setShowModalVerificar(false);
        } catch (error) {
            alert('Error al actualizar datos del paciente');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!pacienteId) {
            alert('Por favor seleccione un paciente');
            return;
        }
        
        if (productos.length === 0) {
            alert('Debe agregar al menos un servicio');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        if (tipoPago === 'credito' && fecha === vencimiento) {
            alert('Para crédito, la fecha de vencimiento debe ser diferente a la fecha del documento');
            return;
        }

        const facturaData = {
            parametrosfev_id: parseInt(prefijo),
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            sedes_id: parseInt(sede),
            fecha_emision: fecha,
            fecha_vence: vencimiento,
            forma_pago: metodoPago,
            tipo_pago: tipoPago,
            valor_bruto: parseFloat(totalBruto),
            valor_total: parseFloat(totalPagar),
            observaciones: observaciones || '',
            codigo_responsabilidad: codigoResponsabilidad,
            codigo_regimen: codigoRegimen,
            codigo_impuesto: codigoImpuesto,
            estado: 0,
            detalle: productos.map(producto => ({
                id: producto.id > 1000000000000 ? null : producto.id, // IDs temporales son null para crear nuevos
                id_listadeprecios: parseInt(producto.id_listadeprecios),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                total: parseFloat(producto.total)
            }))
        };

        try {
            const response = await axios.put('/factura/' + id, facturaData, config);
            if (response.status === 200) {
                alert('Factura actualizada exitosamente');
            }
        } catch (error) {
            console.error('Error completo:', error);
            alert('Error al actualizar la factura: ' + (error.response?.data?.message || error.message));
        }
    };

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Factura</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            <div className="card card-info card-outline">
                                <div className="card card-info-outline">
                                    <div className="card-header">
                                        <h5><b>Información de la Factura</b></h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            
                                            <h5><b>Información del Paciente</b></h5>
                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <label>&nbsp;</label>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info form-control"
                                                            onClick={() => setShowModalPaciente(true)}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Responsabilidad *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={codigoResponsabilidad}
                                                            onChange={(e) => setCodigoResponsabilidad(e.target.value)}
                                                            required
                                                        >
                                                            <option>No responsable</option>
                                                            <option>Régimen simple de tributación</option>
                                                            <option>Gran contribuyente</option>
                                                            <option>Autorretenedor</option>
                                                            <option>Agente de retención IVA</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Tipo de Régimen *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={codigoRegimen}
                                                            onChange={(e) => setCodigoRegimen(e.target.value)}
                                                            required
                                                        >
                                                            <option>No responsable de IVA</option>
                                                            <option>Impuesto sobre las ventas / IVA</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Impuesto *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={codigoImpuesto}
                                                            onChange={(e) => setCodigoImpuesto(e.target.value)}
                                                            required
                                                        >
                                                            <option>No causa</option>
                                                            <option>IVA</option>
                                                            <option>INC</option>
                                                            <option>IVA e INC</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-light"
                                                        onClick={abrirModalVerificar}
                                                    >
                                                        <i className="fas fa-user-check"></i> Verificar Datos
                                                    </button>
                                                </div>
                                            </div>

                                            <hr />

                                            <h5><b>Información de la Factura</b></h5>

                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Fecha del Documento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fecha}
                                                            onChange={(e) => {
                                                                setFecha(e.target.value);
                                                                if (tipoPago === 'contado') {
                                                                    setVencimiento(e.target.value);
                                                                }
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo de Pago *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={tipoPago}
                                                            onChange={(e) => {
                                                                setTipoPago(e.target.value);
                                                                if (e.target.value === 'contado') {
                                                                    setVencimiento(fecha);
                                                                }
                                                            }}
                                                            required
                                                        >
                                                            <option value="contado">Contado</option>
                                                            <option value="credito">Crédito</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Vencimiento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={vencimiento}
                                                            onChange={(e) => setVencimiento(e.target.value)}
                                                            disabled={tipoPago === 'contado'}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Profesional *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={profesional}
                                                            disabled
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {profesionales.map(prof => (
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Sede *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={sede}
                                                            onChange={(e) => setSede(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {sedes.map(s => (
                                                                <option key={s.id} value={s.id}>{s.nombre}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Prefijo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={prefijo}
                                                            disabled
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {parametrosFev.map(p => (
                                                                <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Factura *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={numeroFactura}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Método de Pago *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={metodoPago}
                                                            onChange={(e) => setMetodoPago(e.target.value)}
                                                            required
                                                        >
                                                            <option value="10">Efectivo</option>
                                                            <option value="42">Consignación bancaria</option>
                                                            <option value="1">Instrumento no definido</option>
                                                            <option value="20">Cheque</option>
                                                            <option value="30">Transferencia Crédito</option>
                                                            <option value="31">Transferencia Débito</option>
                                                            <option value="45">Transferencia Crédito Bancario</option>
                                                            <option value="47">Transferencia Débito Bancaria</option>
                                                            <option value="48">Tarjeta Crédito</option>
                                                            <option value="49">Tarjeta Débito</option>
                                                            <option value="ZZZ">Acuerdo mutuo</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label>Clasificación</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={clasificacionFiltro}
                                                            onChange={(e) => setClasificacionFiltro(e.target.value)}
                                                        >
                                                            <option value="">Todas</option>
                                                            {especialidades.map(esp => (
                                                                <option key={esp.id} value={esp.nombre}>{esp.nombre}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <label>Selecciona el Servicio a Facturar</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={productoSeleccionado}
                                                            onChange={(e) => setProductoSeleccionado(e.target.value)}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {getListaPreciosFiltrada().map(servicio => (
                                                                <option key={servicio.id} value={servicio.id}>
                                                                    {servicio.codigo} - {servicio.nombre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-info mt-2"
                                                    onClick={agregarServicio}
                                                >
                                                    Agregar Servicio
                                                </button>
                                            </div>

                                            <hr />

                                            {/* Tabla de productos */}
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: '10%'}}>Código</th>
                                                            <th style={{width: '25%'}}>Descripción</th>
                                                            <th style={{width: '8%'}}>Cant.</th>
                                                            <th style={{width: '12%'}}>Precio</th>
                                                            <th style={{width: '8%'}}>Desc %</th>
                                                            <th style={{width: '15%'}}>Impuesto</th>
                                                            <th style={{width: '12%'}}>Total</th>
                                                            <th style={{width: '10%'}}>Acción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productos.map(producto => (
                                                            <tr key={producto.id}>
                                                                <td>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.codigo}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'codigo', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td style={{fontSize: '14px', padding: '8px'}}>{producto.descripcion}</td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.cantidad}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                        min="1"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.precio}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                        step="0.01"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.porcentaje}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                        min="0"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <select 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.impuesto}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                    >
                                                                        <option value="0">0</option>
                                                                        {impuestos.map(imp => (
                                                                            <option key={imp.id} value={imp.impuesto}>{imp.nombre+' '+imp.impuesto+'%'}</option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={parseFloat(producto.total || 0).toFixed(2)}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{textAlign: 'center'}}>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => eliminarProducto(producto.id)}
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="6" className="text-right"><strong>Total Bruto:</strong></td>
                                                            <td colSpan="2">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={parseFloat(totalBruto || 0).toFixed(2)}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="6" className="text-right"><strong>Total a Pagar:</strong></td>
                                                            <td colSpan="2">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={parseFloat(totalPagar || 0).toFixed(2)}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea 
                                                    className="form-control" 
                                                    rows="5"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder=""
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-info">
                                                    Actualizar Factura
                                                </button>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal para seleccionar paciente */}
                {showModalPaciente && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar Paciente</h5>
                                    <button type="button" className="close" onClick={() => setShowModalPaciente(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    <div className="form-group">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por nombre o documento..."
                                            value={busquedaPaciente}
                                            onChange={(e) => {
                                                setBusquedaPaciente(e.target.value);
                                                setPaginaActual(1);
                                            }}
                                        />
                                    </div>
                                    <div className="table-responsive" style={{ maxHeight: '48vh', overflowY: 'auto' }}>
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Documento</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getPacientesPaginados().map((paciente, index) => (
                                                    <tr key={index}>
                                                        <td>{`${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim()}</td>
                                                        <td>{paciente.numero_documento}</td>
                                                        <td>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => seleccionarPaciente(paciente)}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {/* Paginación */}
                                    {getTotalPaginas() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === 1}
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === getTotalPaginas()}
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalPaciente(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Verificar Datos Paciente */}
                {showModalVerificar && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Verificar Datos del Paciente</h5>
                                    <button type="button" className="close" onClick={() => setShowModalVerificar(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <h6><b>Datos Personales</b></h6>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Primer Nombre</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.primer_nombre || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, primer_nombre: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Segundo Nombre</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.segundo_nombre || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, segundo_nombre: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Primer Apellido</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.primer_apellido || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, primer_apellido: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Segundo Apellido</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.segundo_apellido || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, segundo_apellido: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Tipo Documento</label>
                                                <select 
                                                    className="form-control" 
                                                    value={datosVerificar.tipo_documento || 'CC'}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, tipo_documento: e.target.value})}
                                                >
                                                    <option value="CC">CC</option>
                                                    <option value="CE">CE</option>
                                                    <option value="PA">PA</option>
                                                    <option value="PE">PE</option>
                                                    <option value="RC">RC</option>
                                                    <option value="TI">TI</option>
                                                    <option value="NIT">NIT</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Número Documento</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.numero_documento || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, numero_documento: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Teléfono</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.telefono || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, telefono: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Email</label>
                                                <input 
                                                    type="email" 
                                                    className="form-control" 
                                                    value={datosVerificar.email || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, email: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Fecha Nacimiento</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={datosVerificar.fecha_nacimiento || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, fecha_nacimiento: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Género</label>
                                                <select 
                                                    className="form-control" 
                                                    value={datosVerificar.genero || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, genero: e.target.value})}
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    <option value="M">Masculino</option>
                                                    <option value="F">Femenino</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Estado Civil</label>
                                                <select 
                                                    className="form-control" 
                                                    value={datosVerificar.estado_civil || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, estado_civil: e.target.value})}
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    <option value="Soltero">Soltero</option>
                                                    <option value="Casado">Casado</option>
                                                    <option value="Divorciado">Divorciado</option>
                                                    <option value="Viudo">Viudo</option>
                                                    <option value="Union Libre">Unión Libre</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <hr />
                                    <h6><b>Información de Dirección</b></h6>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Dirección</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.direccion || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, direccion: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Ciudad</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.ciudad || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, ciudad: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Departamento</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.departamento || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, departamento: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <hr />
                                    <h6><b>Información Tributaria</b></h6>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Responsabilidad</label>
                                                <select 
                                                    className="form-control" 
                                                    value={datosVerificar.codigo_responsabilidad || 'No responsable'}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, codigo_responsabilidad: e.target.value})}
                                                >
                                                    <option>No responsable</option>
                                                    <option>Régimen simple de tributación</option>
                                                    <option>Gran contribuyente</option>
                                                    <option>Autorretenedor</option>
                                                    <option>Agente de retención IVA</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Tipo de Régimen</label>
                                                <select 
                                                    className="form-control" 
                                                    value={datosVerificar.codigo_regimen || 'No responsable de IVA'}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, codigo_regimen: e.target.value})}
                                                >
                                                    <option>No responsable de IVA</option>
                                                    <option>Impuesto sobre las ventas / IVA</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Impuesto</label>
                                                <select 
                                                    className="form-control" 
                                                    value={datosVerificar.codigo_impuesto || 'No causa'}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, codigo_impuesto: e.target.value})}
                                                >
                                                    <option>No causa</option>
                                                    <option>IVA</option>
                                                    <option>INC</option>
                                                    <option>IVA e INC</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalVerificar(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-info" onClick={actualizarPaciente}>Actualizar Datos</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default EditarFactura;